export default __webpack_public_path__ + "static/media/map-tab2.55e7ec2f.png";